/**
 * "This tab came in through the phone app's pages" (SCO-583, slice 3).
 *
 * The producer's setup pop-down must never show inside the phone app. The app
 * sets no user agent of its own, only its Home tab has a native bridge, and
 * its remembered device token is absent on Android, on an iPhone with
 * notifications denied, and before the Home tab has loaded. But every tab of
 * the app starts on the mobile pages (`/mobile/*`, the mobile bundle), and the
 * player area is reached from there only by navigating the same tab
 * (`?redirect=/admin/...`). So the mobile entry leaves a mark in the tab's
 * session storage, which survives that navigation and is per tab.
 *
 * The cost: an ordinary browser tab that visited `/mobile` first is treated as
 * the app for the rest of that tab's session and shows no pop-down.
 *
 * The gap that remains: a web view whose session storage is unavailable, or
 * one that reaches the player area without ever loading a mobile page. The
 * real fix is in the app (an application name in its user agent, SCO-825).
 */
var KEY = 'sbb_entered_through_mobile';
/** Called once by the mobile entry point. Never throws. */
export var markEnteredThroughMobile = function () {
    try {
        window.sessionStorage.setItem(KEY, '1');
    }
    catch (_a) {
        // Storage unavailable: see the gap described above.
    }
};
export var enteredThroughMobile = function () {
    try {
        return window.sessionStorage.getItem(KEY) === '1';
    }
    catch (_a) {
        return false;
    }
};
